import { api } from '@shared/api/client';
import { getClientId } from '@shared/clientId';
import type { SubmissionRequest } from '@shared/types/api';

export type TeamInterestSize = '1-5' | '6-15' | '16-50' | '51-200' | '200+';

export interface TeamInterestPayload {
  name: string;
  email: string;
  organisation?: string;
  team_size?: TeamInterestSize;
}

export async function submitTeamInterest(p: TeamInterestPayload): Promise<void> {
  const clientId = getClientId();
  const req: SubmissionRequest<TeamInterestPayload> = {
    tool_id: 'plan_builder_team_interest',
    schema_version: 'v1',
    client_submission_id:
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : 'team-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10),
    submitted_at: new Date().toISOString(),
    user_agent: navigator.userAgent,
    referrer: document.referrer || undefined,
    payload: p,
  };
  await api.submit(clientId, req);
}
